import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// import { ProductConfig, ModelConfig } from '../commons/models';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';

@Component({

  selector: 'my-select-products',
  template: require('./select-products.component.html'),
  styles: [`
   .product { margin-bottom:12px; }
   `]
})

export class SelectProductsComponent {

  @Input()
  public visibility;


  constructor(
    public session: SessionService,
    public config: ConfigService,
    public cartService: CartService,
    private router: Router
  ) {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/select-products.component.ts